import { generatePath, matchPath } from 'react-router-dom'

import { Routes } from 'routes/routes'

const matches = (pathname: string, route: Routes) => !!matchPath({ path: route }, pathname)

/** Where to land after switching project. `null` — stay on the current URL (no projectId in path). */
export const getProjectSwitchPath = (pathname: string, newProjectId: number): string | null => {
  const projectId = String(newProjectId)

  if (matches(pathname, Routes.ScenariosCompare)) {
    return generatePath(Routes.ScenariosCompare, { projectId })
  }

  if (matches(pathname, Routes.Scenario) || matches(pathname, Routes.Scenarios)) {
    return generatePath(Routes.Scenarios, { projectId })
  }

  if (matches(pathname, Routes.Forecast)) {
    return generatePath(Routes.Forecast, { projectId })
  }

  if (matches(pathname, Routes.Perspective) || matches(pathname, Routes.Perspectives)) {
    return generatePath(Routes.Perspectives, { projectId })
  }

  if (matches(pathname, Routes.DemandElasticity)) {
    return generatePath(Routes.DemandElasticity, { projectId })
  }

  if (matches(pathname, Routes.CategoryMarketGrowth)) {
    return generatePath(Routes.CategoryMarketGrowth, { projectId })
  }

  if (matches(pathname, Routes.MasterDataHierarchy)) {
    return Routes.MasterData
  }

  return null
}
